import { render, staticRenderFns } from "./InternetCheck.vue?vue&type=template&id=2030b44e"
import script from "./InternetCheck.vue?vue&type=script&lang=js"
export * from "./InternetCheck.vue?vue&type=script&lang=js"
import style0 from "./InternetCheck.vue?vue&type=style&index=0&id=2030b44e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports